module.exports = __webpack_public_path__ + "img/fi.475a737e.svg";